import { ArrowDropDownRounded } from '@mui/icons-material';
import { Avatar, Box, Skeleton, Typography } from '@mui/material';

type UserProfile = {
  given_name?: string;
  family_name?: string;
  email?: string;
  name?: string;
};

interface UserAvatarProps {
  onClick?: (event: React.MouseEvent) => void;
  isLoading: boolean;
  user: UserProfile | null;
}

export const UserAvatar = (props: UserAvatarProps) => {
  const { onClick, user, isLoading } = props;

  const firstName = user?.name?.split(' ')[0] || user?.given_name || '';
  const lastName = user?.name?.split(' ')[1] || user?.family_name || '';

  const userName =
    lastName && firstName
      ? `${firstName} ${lastName}`
      : firstName || lastName || user?.email || 'User';
  const userNameInitials = user
    ? `${firstName.charAt(0).toUpperCase()}${lastName
        ?.charAt(0)
        .toUpperCase()}` || 'U'
    : 'U';

  const onClickAction = (event: React.MouseEvent) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="8px"
      onClick={onClickAction}
      sx={{ cursor: 'pointer' }}
    >
      {!isLoading ? (
        <>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: 'primary.main',
              fontSize: '14px',
            }}
          >
            {userNameInitials}
          </Avatar>
          <Typography
            variant="body2"
            sx={{
              display: { xs: 'none', sm: 'block' },
              color: 'text.primary',
            }}
          >
            {userName}
          </Typography>
          <ArrowDropDownRounded
            sx={{ color: 'text.secondary', fontSize: '20px' }}
          />
        </>
      ) : (
        <>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={100} height={20} />
        </>
      )}
    </Box>
  );
};
